// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Cr-z","giftOrPromoSelector":"Dr-z","disabled":"Er-z","subTitle":"Fr-z","selectShipAddressMessage":"Gr-z","changePayment":"Hr-z"};